import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const FlexWrapper = styled(Box)`
    display: flex;
`;
